const SUBSCRIPTION_ACTION_TYPES = {
  USER_PROFILE: {
    IDENTIFY_USER: "IDENTIFY_USER",
    IDENTIFY_PROFILE: "IDENTIFY_PROFILE",
    IDENTIFY_PROFILES: "IDENTIFY_PROFILES",
    SET_USER: "SET_USER",
    SET_PROFILE: "SET_PROFILE",
    SET_PROFILES: "SET_PROFILES",
    ERROR: "ERROR"
  },
  PRODUCTS: {
    GET: "GET",
    RESET: "RESET",
    GET_ERROR: "GET_ERROR",
    GET_SUCCESS: "GET_SUCCESS",
    GET_LOADING: "GET_LOADING",
    SET_SELECTED_PRODUCT: "SET_SELECTED_PRODUCT"
  },
  RENEW: {
    POST: "POST",
    RESET: "RESET",
    RENEW_ERROR: "RENEW_ERROR",
    RENEW_SUCCESS: "RENEW_SUCCESS",
    RENEW_LOADING: "RENEW_LOADING"
  }
};

export default SUBSCRIPTION_ACTION_TYPES;
